'use strict';

angular.module('cgmemApp')
	.controller('ProfileCtrl', function ($q, $rootScope, $scope, $state, $http, $uibModal, $log, AppConfig, WorkingAccount, Transaction, User) {
		$q.all([AppConfig.get(), WorkingAccount.get(), Transaction.initialize(), User.get()])
			.then(function (d) {
				$scope.profile = d[1];
				$scope.appConfig = d[0];
				$scope.user = d[3];

				$scope.isInGroup = User.isInGroup;
				if (User.isInGroup('poolstaff'))
					$state.go('authenticated.frontdesk');
				$scope.accountTypes = d[0].accountTypes;

				$scope.foreignAccount = function () {
					var u = User.getSync();
					var a = WorkingAccount.getSync();
					return ((u && a && a.account && u.accountId != a.account._id) ? a.account.accountNumber : false);
				}
				$scope.resetAccountSelection = function () {
					//$log.log("Resetting to default account");
					WorkingAccount.get('0')
						.then(function (a) {
							//$log.log("Account reset to",a.account.accountNumber);
						}, function (err) {
							$log.error("WorkingAccountReload failed:", err);
						});
				}
			})
			.catch(function (err) {
				$log.warn('DashboardCtrl: failure: ', err);
				var returnedErr = (err.data && err.config.url) ? (err.data + ": " + err.config.url) : err;
				$rootScope.$emit('generalAlert', 'Failed to load your account details.  Please check network connectivity or contact Country Glen.');
			});

		$scope.showOldTxns = false;

		$scope.shop = function () {
			$state.go('authenticated.shop.select');
		}

		$scope.pay = function () {
			$state.go('authenticated.shop.pay');
		}

		$scope.editMember = function (m) {
			$state.go('authenticated.editmember', { memberId: (m ? m._id : null) });
		}

		$scope.editAccount = function (m) {
			$state.go('authenticated.accountEdit');
		}

		$scope.manualTransaction = function () {
			$scope.manTrans = {
				type: 'checkpayment', multiplier: -1,
				amount: ($scope.profile.account.balance > 0 ? $scope.profile.account.balance : 0),
				extRef: '', note: '', newAccountType: "NEW"
			}
			$scope.showManForm = true;
		}

		$scope.manOk = function () {
			$scope.loading = true;
			if ($scope.manTrans.amount <= 0 && $scope.manTrans.type != 'accountTypeAdjustment') {
				$rootScope.$emit('generalAlert', 'Amount must be > 0');
				$scope.loading = $scope.showManForm = false;
				return;
			}

			if ($scope.manTrans.type == 'checkrefund' || $scope.manTrans.type == 'ccrefund' || $scope.manTrans.type == 'cashrefund')
				$scope.manTrans.multiplier = 1;

			var amt = ($scope.manTrans.type == 'accountTypeAdjustment' ? 0 : $scope.manTrans.amount * $scope.manTrans.multiplier);

			var t = new Transaction.transaction(null, null, $scope.manTrans.type, amt,
				($scope.manTrans.type == 'accountTypeAdjustment' ? { postType: $scope.manTrans.newAccountType } : null),
				$scope.manTrans.note);
			$http.post('/api/transactions', [t])
				.then(function (res) {
					return WorkingAccount.get(null, true);
				})
				.then(function (res) {
					$scope.loading = false;
					$scope.showManForm = false;
				})
				.catch(function (err) {
					$scope.loading = false;
					$scope.showManForm = false;
					$log.warn("transaction save failed", err)
					$rootScope.$emit('generalAlert', 'Saving manual transaction failed: ' + err.data);
				});
		}

		$scope.manCancel = function () {
			$scope.showManForm = false;
		}

		$scope.reverse = function (t) {
			var modalInstance = $uibModal.open({
				templateUrl: 'reverseModal.html',
				controller: 'reverseModalInstanceCtrl',
				resolve: {
					t: function () {
						return t;
					}
				}
			});

			modalInstance.result.then(function () {
				$log.debug("Reversing Transaction", t);
				Transaction.reverse(t)
					.then(function () {
						$log.log('Reversed OK')
						// need to do some reloading...
						$state.go($state.current, {}, { reload: true }); //second parameter is for $stateParams
					})
					.catch(err => {
						$log.log('Error reversing transaction');
						$rootScope.$emit('generalAlert', 'Delete failed.  Are there dependent transactions?')
					});
			})
			.catch(err => null);
		};

		$scope.ccrefund = function (t) {
			var modalInstance = $uibModal.open({
				templateUrl: 'ccrefundModal.html',
				controller: 'ccrefundModalInstanceCtrl',
				resolve: {
					t: function () {
						return t;
					}
				}
			});

			modalInstance.result.then(result => {
				$log.debug("Refunding based on Transaction", t);
				$scope.loading = true;
				var refund = new Transaction.transaction(null, null, 'ccrefund', result.amount, null, result.note);
				refund.chargeRef = t.extRef;		// reference to the original charge
				$http.post('/api/transactions', [refund])
					.then(function (res) {
						return WorkingAccount.get(null, true);
					})
					.then(function (res) {
						$scope.loading = false;
					})
					.catch(function (err) {
						$scope.loading = false;
						$log.warn("transaction save failed", err)
						$rootScope.$emit('generalAlert', 'Processing refund failed: ' + err.data);
					});

			}, function () {
				// cancelled
			});
		};
		$scope.tokenizeIds = (str) => {
			let p1 = str.replace('{user}', ($scope.user && $scope.user._id) || '');
			return p1.replace('{account}', ($scope.profile && $scope.profile.account._id) || '');
		}

	})
	.controller('reverseModalInstanceCtrl', function ($scope, $uibModalInstance, t) {
		$scope.t = t;
		$scope.ok = function () {
			$uibModalInstance.close();
		};

		$scope.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};
	})
	.controller('ccrefundModalInstanceCtrl', function ($scope, t) {
		$scope.amount = -t.amount;
		$scope.note = '';
	});
